import { Image, Text, View } from "@react-pdf/renderer";
import React from "react";

import { sectionStyles } from "../styles";

interface IReviewsSummarySectionProps {
  title: string;
  summaryText: string | undefined;
  improvements: string[] | undefined;
  commentsChartImage: string | undefined;
  labels: {
    summary: string;
    improvements: string;
    noImprovements: string;
    noData: string;
  };
}

export const ReviewsSummarySection: React.FunctionComponent<
  IReviewsSummarySectionProps
> = ({ title, summaryText, improvements, commentsChartImage, labels }) => {
  return (
    <View style={sectionStyles.container}>
      <Text style={sectionStyles.title}>{title}</Text>
      <View style={sectionStyles.divider} />
      <Text style={sectionStyles.subTitle}>{labels.summary}</Text>
      {summaryText ? (
        <Text style={sectionStyles.summaryText}>{summaryText}</Text>
      ) : (
        <Text style={sectionStyles.noData}>{labels.noData}</Text>
      )}
      <Text style={sectionStyles.subTitle}>{labels.improvements}</Text>
      {improvements && improvements.length > 0 ? (
        <View style={sectionStyles.listContainer}>
          {improvements.map((item, index) => (
            <View key={index} style={sectionStyles.listItem}>
              <Text style={sectionStyles.listBullet}>•</Text>
              <Text style={sectionStyles.listItemText}>{item}</Text>
            </View>
          ))}
        </View>
      ) : (
        <Text style={sectionStyles.noData}>{labels.noImprovements}</Text>
      )}
      {commentsChartImage && (
        <View style={sectionStyles.reviewsCommentsImageContainer}>
          <Image src={commentsChartImage} style={sectionStyles.chartImage} />
        </View>
      )}
    </View>
  );
};
